<script>
  import { getPublicClient, writeContract } from "@wagmi/core";

  import { chainExplorer, walletAddress } from "../stores.js";
  import { getABI, getBalance, getContractValue } from "../utils.js";

  export let chain;
  export let address;

  let loadingData = true;
  let max = 0;

  let disposing = false;
  let txHash;
  let feedback;

  $: $walletAddress, init();

  const init = async () => {
    if ($walletAddress) {
      const [ collection, tokenId ] = await Promise.all([
        getContractValue(chain, address, 'collection'),
        getContractValue(chain, address, 'tokenId')
      ]);
      max = await getBalance(chain, $walletAddress, collection, tokenId);
      loadingData = false;
    }
  }

  const dispose = async () => {
    disposing = true;
    try {
      const { hash } = await writeContract({
        chainId: chain, address: address, abi: await getABI(address, chain), functionName: 'dispose'
      });
      txHash = hash;
    } catch (err) {
      if (err.shortMessage === 'User rejected the request.') {
        dispatch('user-cancel');
        new CustomEvent('user-cancel');
      } else {
        console.log(err)
        dispatch('error', err);
        new CustomEvent('error', { detail: err });
      }
      disposing = false;
      return;
    }

    max -= 1;

    dispatch('hashed', txHash);
    new CustomEvent('hashed', { detail: txHash });
    const receipt = await getPublicClient().waitForTransactionReceipt({ hash: txHash });
    dispatch('disposed', receipt)
    new CustomEvent('disposed', { detail: receipt });
    feedback = 'Disposed!';
    setTimeout(() => { feedback = undefined; }, 5000);
    txHash = undefined;
    disposing = false;
  }
</script>

{#if loadingData}
  Loading...
{:else if feedback}
  <span class={ $$props.class } class:lt-build={ true } class:feedback={ true }>{ feedback }</span>
{:else if txHash}
  <a href="{ $chainExplorer.url }/tx/{ txHash }" target="_blank">View tx</a>
{:else if max}
  <button class={ $$props.class } class:lt-build={ true } on:click={ dispose }>
    {#if disposing}
      <span class="loading loading-spinner"></span>
    {/if}
    Dispose
  </button>
{/if}